export default "https://studio-ui-deployments.apollographql.com/build/static/assets/favicon-staging-dark.66c9a8e894eb8492d05d73b6c67465fc.png";